/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState, useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import { useFormikContext } from "formik";
import { Form } from 'formik';
import { Prompt } from 'react-router-dom';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';
import {
  StepBox, NavigationalButtonsBox, SaveButton, setErrorMsg, rootCss, unsavedMsg, getImgOptions, 
} from '../Helpers/CopyAndFunctions';


const FormContent = ({ eligibleData, handleSave, showSuccess, showError }) => {
  const { dirty, errors, isSubmitting, values } = useFormikContext();
  const [selectedKey, setSelectedKey] = useState('0');
  const imageOptions = getImgOptions(values);

  const nextOnClick = useCallback(() => setSelectedKey(prev => String(Number(prev) + 1)), []);
  const prevOnClick = useCallback(() => setSelectedKey(prev => String(Number(prev) - 1)), []);
  const handleLinkClick = useCallback((item) => setSelectedKey(String(item.props.itemKey)), []);

  return (
      <Form css={rootCss}>
          <Prompt when={dirty} message={unsavedMsg} />
          <div className="mt-1 form-container">
              <StepBox 
                selectedKey={selectedKey} 
                handleLinkClick={handleLinkClick} 
                eligibleData={eligibleData} 
                imageOptions={imageOptions} 
              />
              <NavigationalButtonsBox
                  selectedKey={selectedKey}
                  nextOnClick={nextOnClick}
                  prevOnClick={prevOnClick}
              />
              <SaveButton handleSave={handleSave} dirty={dirty} submitting={isSubmitting} />
          </div>
          <SuccessComponent successMessage="Series Settings Updated." showSuccess={showSuccess} />
          <ErrorComponent errorMessage={setErrorMsg(showError, errors)} showError={showError} />
      </Form>
  );
};

export default FormContent;
